module.exports = __webpack_public_path__ + "img/mobile-icon.e20a2753.svg";